import React, { useEffect, useRef } from "react";
import { getWsUrl } from "./api";

export function useTenantSocket(slug, onMessage) {
  const ref = useRef(null);
  const handlerRef = useRef(onMessage);
  handlerRef.current = onMessage;

  useEffect(() => {
    if (!slug) return undefined;
    let closed = false;
    let retryTimer = null;

    const connect = () => {
      const ws = new WebSocket(getWsUrl(slug));
      ref.current = ws;
      ws.onmessage = (evt) => {
        if (evt.data === "pong") return;
        try {
          const msg = JSON.parse(evt.data);
          if (handlerRef.current) handlerRef.current(msg);
        } catch {
          /* ignore non-json */
        }
      };
      ws.onclose = () => {
        ref.current = null;
        if (!closed) {
          retryTimer = setTimeout(connect, 2000);
        }
      };
      ws.onerror = () => {
        try { ws.close(); } catch { /* noop */ }
      };
    };

    connect();
    const pingInterval = setInterval(() => {
      try { ref.current && ref.current.readyState === 1 && ref.current.send("ping"); } catch { /* noop */ }
    }, 25000);

    return () => {
      closed = true;
      clearInterval(pingInterval);
      if (retryTimer) clearTimeout(retryTimer);
      if (ref.current) {
        try { ref.current.close(); } catch { /* noop */ }
        ref.current = null;
      }
    };
  }, [slug]);
}
